'use strict';

module.exports = function (ngModule) {
    ngModule.directive('machIcon', require('./machicon'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/directives/machicon/index.js
 **/